<template>
  <AuthMobileTemplate v-if="isMobile" is-login>
    <LoginForm is-mobile />
  </AuthMobileTemplate>
  <AuthDesktopTemplate v-else>
    <template #button>
      Vous n'avez pas de compte ?
      <RouterLink v-focus class="btn-primary" to="/register"
        >Inscription</RouterLink
      >
    </template>
    <template #form>
      <LoginForm class="form-wrapper" />
    </template>
  </AuthDesktopTemplate>
</template>

<script setup>
import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";
import AuthMobileTemplate from "@follaw-fr/components/auth/templates/AuthMobileTemplate.vue";
import AuthDesktopTemplate from "@follaw-fr/components/auth/templates/AuthDesktopTemplate.vue";
import LoginForm from "@follaw-fr/components/auth/organisms/LoginForm.vue";
const { width } = useWindowSize();

const isMobile = computed(() => width.value < 1000);
</script>
<style scoped>
.form-wrapper {
  margin: auto;
  width: 337px;
}
</style>
